export const BUILTIN_CATALOG = {
  "schemaVersion": 1,
  "version": "2026-10-08.1",
  "providers": {
    "deepseek": {
      "defaultModel": "deepseek-flash",
      "models": [
        {
          "id": "deepseek-flash",
          "label": "DeepSeek Flash",
          "status": "active"
        },
        {
          "id": "deepseek-v4-pro",
          "label": "DeepSeek V4 Pro",
          "status": "active"
        }
      ],
      "migrations": {
        "deepseek-v4-flash": "deepseek-flash",
        "deepseek-v4-flash-vision-exp": "deepseek-flash"
      }
    },
    "gemini": {
      "defaultModel": "gemini-3.8-flash",
      "models": [
        {
          "id": "gemini-3.8-flash",
          "label": "Gemini 3.8 Flash",
          "status": "active"
        },
        {
          "id": "gemini-3.6-flash",
          "label": "Gemini 3.6 Flash",
          "status": "active"
        },
        {
          "id": "gemini-3.5-flash-lite",
          "label": "Gemini 3.5 Flash-Lite",
          "status": "active"
        },
        {
          "id": "gemini-3.1-flash-lite",
          "label": "Gemini 3.1 Flash-Lite",
          "status": "active"
        },
        {
          "id": "gemini-3.1-pro-preview",
          "label": "Gemini 3.1 Pro（预览）",
          "status": "active"
        },
        {
          "id": "gemini-3-flash-preview",
          "label": "Gemini 3 Flash（预览）",
          "status": "active"
        }
      ],
      "migrations": {
        "gemini-3.1-flash-lite-preview": "gemini-3.1-flash-lite"
      }
    }
  }
};
